import { BrokerProduct } from '@/services/brokers/types';
import { Link } from '@tanstack/react-router';
import { ArrowRight, Building, HardHat, Home } from 'lucide-react';
import type { ReactNode } from 'react';

export type ProductCardProps = {
  product: BrokerProduct;
};

function ProductIcon({
  category,
}: {
  category: BrokerProduct['category'];
}): ReactNode {
  switch (category) {
    case 'BUSINESS_INSURANCE':
      return <Building className='h-5 w-5' strokeWidth={1.6} />;
    case 'RD_EQUIPMENT':
      return <HardHat className='h-5 w-5' strokeWidth={1.6} />;
    case 'HOME_INSURANCE':
    default:
      return <Home className='h-5 w-5' strokeWidth={1.6} />;
  }
}

export function ProductCard({ product }: ProductCardProps) {
  return (
    <div className='rounded-3xl bg-white p-5 lg:p-6 shadow-[0px_4px_24px_0px_rgba(15,22,30,0.08)] w-full max-w-sm'>
      <div className='flex flex-col'>
        <div className='text-alba-blue-500'>
          <ProductIcon category={product.category || 'HOME_INSURANCE'} />
        </div>

        <div className='mt-3'>
          <div className='text-[24px] leading-[100%] font-gotham text-alba-blue-900'>
            {product.name}
          </div>
          <p className='mt-2 text-sm text-alba-gray-700 max-w-xs'>
            {product.description}
          </p>
        </div>
      </div>

      <div className='mt-5 border-t border-alba-gray-200 w-full' />

      <div className='mt-3 flex items-center justify-between'>
        <Link
          to='/quotes/products/new'
          search={{
            productId: product.productId ?? '',
            category: product.category ?? '',
            productCode: product.productCode ?? '',
            // `stepCode`/`quoteFlow` entraram no contrato da rota com o
            // wizard de edição (dev). O `validateSearch` preenche os dois
            // por omissão, então o comportamento é o mesmo — declarar aqui
            // é o que faz o link satisfazer o tipo da rota.
            stepCode: '',
            quoteFlow: 'new' as const,
          }}
          className='text-base text-alba-green-500'
        >
          Fazer cotação
        </Link>

        <Link
          to='/quotes/products/new'
          search={{
            productId: product.productId ?? '',
            category: product.category ?? '',
            productCode: product.productCode ?? '',
            // `stepCode`/`quoteFlow` entraram no contrato da rota com o
            // wizard de edição (dev). O `validateSearch` preenche os dois
            // por omissão, então o comportamento é o mesmo — declarar aqui
            // é o que faz o link satisfazer o tipo da rota.
            stepCode: '',
            quoteFlow: 'new' as const,
          }}
          className='ml-6 inline-flex items-center justify-center rounded-full p-1 text-alba-green-500'
          aria-label='Selecionar produto'
        >
          <ArrowRight className='h-4 w-4' strokeWidth={1.6} />
        </Link>
      </div>
    </div>
  );
}
